import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useState } from "react";

const links = [
  { to: "/inventory", label: "Inventory" },
  { to: "/sell", label: "Sell Your Car" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="glass-header sticky top-0 z-50" data-testid="site-header">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16">
        <div className="flex items-center justify-between h-20">
          <Link to="/" data-testid="logo-link" className="flex items-baseline gap-2">
            <span className="font-display text-2xl md:text-[26px] font-medium tracking-tight text-black">
              ROYALE
            </span>
            <span className="font-display text-2xl md:text-[26px] font-light tracking-tight text-[#9D8C70]">
              YAAN
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-10">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `text-sm tracking-wide transition-colors ${
                    isActive ? "text-black" : "text-gray-500 hover:text-black"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/sell"
              data-testid="header-sell-cta"
              className="btn-primary text-sm font-medium px-6 py-3 rounded-sm"
            >
              Sell Your Car
            </Link>
          </div>

          <button
            className="md:hidden text-black"
            onClick={() => setOpen((v) => !v)}
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>

        {open && (
          <div className="md:hidden pb-6 pt-2 space-y-3" data-testid="mobile-menu">
            {links.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className="block text-sm text-gray-700"
              >
                {l.label}
              </Link>
            ))}
          </div>
        )}
      </div>
    </header>
  );
}
